import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  constructor() {}

  getCompanyID() {
    let companyStorage = JSON.parse(localStorage.getItem('company')!);
    return companyStorage.idCompany;
  }
  getUser() {
    let userStorage = JSON.parse(localStorage.getItem('user')!);
    return userStorage.username;
  }
  getidUser() {
    let userStorage = JSON.parse(localStorage.getItem('user')!);
    return userStorage.idUser;
  }
  getUseEmail() {
    let userStorage = JSON.parse(localStorage.getItem('user')!);
    return userStorage.useEmail;
  }
  getRucCompany() {
    let companyStorage = JSON.parse(localStorage.getItem('company')!);
    return companyStorage.comDocument;
  }
  getRazSocialCompany() {
    let companyStorage = JSON.parse(localStorage.getItem('company')!);
    return companyStorage.comName;
  }
  getUseName() {
    let userStorage = JSON.parse(localStorage.getItem('user')!);
    return userStorage.useName;
  }
  getUseLastName() {
    let userStorage = JSON.parse(localStorage.getItem('user')!);
    return userStorage.useLastName;
  }
  getLocationID() {
    let userStorage = JSON.parse(localStorage.getItem('user')!);
    return userStorage.idLocation;
  }
  getUserRoles(){
    let userStorage = JSON.parse(localStorage.getItem('user')!);
    return userStorage.authorities;
  }
  formatElapsedTime(elapsedTime: number) {
    const seconds = Math.floor(elapsedTime / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    return (hours >0)?`${hours} H, ${minutes % 60} M`: `${minutes % 60} M`;
  }
}
